import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import { Link } from 'ui/links';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const Wrapper = styled.div`
  padding: ${spacing.x6} 0;
`;

const DescriptionWrapper = styled.div`
  max-width: ${pxToRem(460)};
`;

export const Error = () => (
  <Wrapper>
    <EmptyState
      Illustration={ErrorStatePageError}
      title="Oops!"
      subtitle={
        <DescriptionWrapper>
          We had a problem fetching this page.{' '}
          <Link href="/settings/frequencyManagement">Click here</Link> to go back and try again.
        </DescriptionWrapper>
      }
    />
  </Wrapper>
);
